import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { UsDateString, parseUsOrIso } from 'core/utils/date';
import './bankHolidayWarningModal.scss';

export interface BankHolidayCharge {
    /** MM-DD-YYYY, as the date step holds its dates. */
    date: UsDateString;
}

interface BankHolidayWarningModalProps {
    open: boolean;
    dates: BankHolidayCharge[];
    onBack: () => void;
    onContinue: () => void;
}

/**
 * Shown when a booking that would normally cost nothing lands on a bank holiday.
 * Requesters book open days months ahead, in bulk, and a bank holiday caught up
 * in the run is easy to miss — the site's opening hours do not apply that day,
 * so the shift is charged.
 */
const BankHolidayWarningModal: FC<BankHolidayWarningModalProps> = ({
    open, dates, onBack, onContinue,
}) => (
    <Modal
        open={open}
        onCancel={onBack}
        footer={null}
        width={480}
        className="bank-holiday-warning-modal"
        centered>
        <div className="bank-holiday-warning-container">
            <h2 className="heading">Warning! Bank Holiday Charges Will Apply</h2>
            <p className="description">
                The following dates fall on a bank holiday and will be charged:
            </p>
            <ul className="bank-holiday-dates">
                {dates.map(({ date }) => (
                    <li key={date}>
                        <strong>{parseUsOrIso(date).format('dddd D MMMM YYYY')}</strong>
                    </li>
                ))}
            </ul>
            <div className="bank-holiday-warning-buttons">
                <Button type="primary" className="confirm-button" onClick={onContinue}>
                    Continue
                </Button>
                <Button type="default" className="cancel-button" onClick={onBack}>
                    Back
                </Button>
            </div>
        </div>
    </Modal>
);

export default BankHolidayWarningModal;
